// ============================================
// Path: /frontend/src/components/AgentCard.jsx
// Purpose: Displays agent/dealer card with avatar and link to their listings
// ============================================

import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader } from './ui/card';
import { Avatar, AvatarFallback } from './ui/avatar';
import { Button } from './ui/button';
import { Skeleton } from './ui/skeleton';
import { ArrowRight } from 'lucide-react';

export function AgentCard({ agentId, name, email, isCarYard = false }) {
  console.log('[AgentCard] Rendering agent card:', { agentId, name, email, isCarYard });

  return (
    <Card className="flex flex-col items-center justify-center text-center p-2 sm:p-3 md:p-4 transition-all hover:shadow-lg hover:-translate-y-1">
      <CardHeader className="p-1 sm:p-2">
        <Avatar className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 mx-auto border-2 border-primary/20">
          <AvatarFallback className="text-2xl sm:text-3xl md:text-4xl bg-muted">
            {name ? name.charAt(0).toUpperCase() : 'A'}
          </AvatarFallback>
        </Avatar>
      </CardHeader>
      <CardContent className="p-2 sm:p-3 flex-grow w-full">
        <p className="font-bold text-sm sm:text-base md:text-lg line-clamp-2 mb-1">{name || (isCarYard ? 'Unnamed Dealer' : 'Unnamed Agent')}</p>
        <p className="text-xs sm:text-sm text-muted-foreground truncate">{email}</p>
      </CardContent>
      <Button asChild variant="secondary" className="mt-2 sm:mt-3 md:mt-4 w-full text-xs sm:text-sm h-9 sm:h-10">
        <Link 
          to={`/agent/${agentId}`}
          onClick={() => console.log('[AgentCard] Viewing listings for agent:', agentId)}
        >
          View Listings <ArrowRight className="ml-1 sm:ml-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
        </Link>
      </Button>
    </Card>
  );
}

export const AgentCardSkeleton = () => {
  console.log('[AgentCard] Rendering skeleton loader');
  
  return (
    <div className="p-2 sm:p-3 md:p-4 border rounded-lg space-y-2 sm:space-y-3 md:space-y-4">
      <Skeleton className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-full mx-auto" />
      <div className="space-y-1.5 sm:space-y-2">
        <Skeleton className="h-4 sm:h-5 md:h-6 w-3/4 mx-auto" />
        <Skeleton className="h-3 sm:h-4 w-full mx-auto" />
      </div>
      <Skeleton className="h-9 sm:h-10 w-full" />
    </div>
  );
};